var map = {
	"./Aerial view of Asagidi river.jpg": 940,
	"./Aerial view of Idofin Quarters.jpg": 818,
	"./Aerial view of Ijemu from Atiba.jpg": 355,
	"./Aerial view of Iloro Ekiti.jpg": 685,
	"./Aerial view of Iloro roundabout.jpg": 62,
	"./Aerial view of Iloro.jpg": 113,
	"./Aerial view of Irewolede LCDA.jpg": 734,
	"./Aerial view of King's Palace.jpg": 627,
	"./Aerial view of Oke Owa.jpg": 190,
	"./Aerial view of the Place and Town Hall.jpg": 916,
	"./African church Isalu.jpg": 59,
	"./Asagidi.jpg": 300,
	"./Ayetoro Iloro High School Aerial view.jpg": 843,
	"./Ayetoro Iloro High School.jpg": 742,
	"./ILORO-EKITI PROGRESSIVE UNION.jpeg": 253,
	"./Igi Ose The Bao Bao tree.jpg": 559,
	"./Iloro Community High School.jpg": 636,
	"./Irewolede LCDA.jpg": 535,
	"./Isalu Aerial view.jpg": 385,
	"./Isalu.jpg": 936,
	"./King's Palace.jpg": 45,
	"./Palace compound.jpg": 899,
	"./Saint Michael African church.jpg": 63,
	"./Town Hall.jpg": 61,
	"./VENITH UNIVERSITY.jpg": 428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 510;